export default function KPICard({ label, value, icon, color }) {
  return (
    <div className="kpi-card" style={{ borderColor: color, boxShadow: `0 2px 8px ${color}22` }}>
      <div className="kpi-icon">{icon}</div>
      <div>
        <div className="kpi-value" style={{ color }}>{value}</div>
        <div className="kpi-label">{label}</div>
      </div>
    </div>
  );
}
